import { render, staticRenderFns } from "./TurnaroundSingle.vue?vue&type=template&id=25dd879f"
import script from "./TurnaroundSingle.vue?vue&type=script&lang=js"
export * from "./TurnaroundSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports